import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatDividerModule } from '@angular/material/divider';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

import { IonicModule } from '@ionic/angular';

import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { TranslateModule } from '@ngx-translate/core';

import { ComponentsModule } from '@ridango/components';
import { CoreModule } from '@ridango/core';

import { BasePageComponent } from './components/base-page/base-page.component';
import { BaseSubPageComponent } from './components/base-sub-page/base-sub-page.component';
import { FooterAppComponent } from './components/footer/footer-app/footer-app.component';
import { FooterStwComponent } from './components/footer/footer-stw/footer-stw.component';
import { FooterTemplateGlComponent } from './components/footer/footer-template-gl/footer-template-gl.component';
import { FooterTemplateVlComponent } from './components/footer/footer-template-vl/footer-template-vl.component';
import { FooterTemplateFiveColsComponent } from './components/footer/footer-template-five-cols/footer-template-five-cols.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderShoppingCartCountdownTimerVisualComponent } from './components/header-shopping-cart-countdown-timer-visual/header-shopping-cart-countdown-timer-visual.component';
import { CartEmptiedNotificationModalComponent } from './components/header-shopping-cart-countdown-timer/cart-emptied-notification-modal/cart-emptied-notification-modal.component';
import { CartEndWarningModalComponent } from './components/header-shopping-cart-countdown-timer/cart-end-warning-modal/cart-end-warning-modal.component';
import { HeaderShoppingCartCountdownTimerComponent } from './components/header-shopping-cart-countdown-timer/header-shopping-cart-countdown-timer.component';
import { HeaderShoppingCartComponent } from './components/header-shopping-cart/header-shopping-cart.component';
import { HeaderLandingTemplateGlComponent } from './components/header/header-landing-template-gl/header-landing-template-gl.component';
import { HeaderLandingTemplateVlComponent } from './components/header/header-landing-template-vl/header-landing-template-vl.component';
import { HeaderStwComponent } from './components/header/header-stw/header-stw.component';
import { HeaderTemplateComponent } from './components/header/header-template/header-template.component';
import { HeaderComponent } from './components/header/header.component';
import { LandingFooterComponent } from './components/landing-footer/landing-footer.component';
import { LandingHeaderComponent } from './components/landing-header/landing-header.component';
import { MobileMenuComponent } from './components/mobile-menu/mobile-menu.component';
import { SplashScreenLegacyComponent } from './components/splash-screen/splashscreen-legacy/splash-screen-legacy.component';
import { FooterAppLinkComponent } from './components/footer/footer-app/footer-app-link/footer-app-link.component';
import { SwiperModule } from 'swiper/angular';
import { WidgetsModule } from '@ridango/widgets';
import { SelectLanguageDialogComponent } from './components/mobile-menu/select-language-dialog/select-language-dialog.component';
import { NewMobileMenuComponent } from './components/mobile-menu/new-mobile-menus/new-mobile-menu/new-mobile-menu.component';
import { AboutAppComponent } from './components/about-app/about-app.component';
import { MobileMenuVlComponent } from './components/mobile-menu/new-mobile-menus/mobile-menu-vl/mobile-menu-vl.component';
import { NewMobileMenuWrapperComponent } from './components/mobile-menu/new-mobile-menus/new-mobile-menu-wrapper/new-mobile-menu-wrapper.component';
import { HeaderShoppingCartV2Component } from './components/header-shopping-cart-v2/header-shopping-cart-v2.component';
import { CartEndWarningModalV2Component } from './components/header-shopping-cart-v2/cart-end-warning-modal-v2/cart-end-warning-modal-v2.component';
import { CartEmptiedNotificationModalV2Component } from './components/header-shopping-cart-v2/cart-emptied-notification-modal-v2/cart-emptied-notification-modal-v2.component';

import { WalletLoadingPageComponent } from './components/wallet-loading-page-v1/wallet-loading-page.component';
import { WalletLoadingPageV2Component } from './components/wallet-loading-page-v2/wallet-loading-page-v2.component';
import { WalletLoadingPageV2SelectAmountComponent } from './components/wallet-loading-page-v2/select-amount/select-amount.component';
import { WalletLoadingPageV2ChooseATicketComponent } from './components/wallet-loading-page-v2/choose-a-ticket/choose-a-ticket.component';
import { WalletLoadingPageV2SelectCardComponent } from './components/wallet-loading-page-v2/select-card/select-card.component';
import { DropdownMenuComponent } from './components/header/header-stw/dropdown-menu/dropdown-menu.component';
import { MobileDropdownMenuComponent } from './components/mobile-menu/mobile-dropdown-menu/mobile-dropdown-menu.component';
import { OverlayModule } from '@angular/cdk/overlay';

@NgModule({
    declarations: [
        HeaderComponent,
        FooterComponent,
        BasePageComponent,
        BaseSubPageComponent,
        MobileMenuComponent,
        NewMobileMenuComponent,
        NewMobileMenuWrapperComponent,
        MobileMenuVlComponent,
        SelectLanguageDialogComponent,
        HeaderShoppingCartComponent,
        HeaderShoppingCartCountdownTimerVisualComponent,
        HeaderShoppingCartCountdownTimerComponent,
        CartEmptiedNotificationModalComponent,
        CartEndWarningModalComponent,
        LandingHeaderComponent,
        LandingFooterComponent,
        HeaderLandingTemplateVlComponent,
        HeaderLandingTemplateGlComponent,
        HeaderTemplateComponent,
        HeaderStwComponent,
        FooterTemplateGlComponent,
        FooterTemplateVlComponent,
        FooterTemplateFiveColsComponent,
        FooterStwComponent,
        FooterAppComponent,
        SplashScreenLegacyComponent,
        FooterAppLinkComponent,
        AboutAppComponent,
        HeaderShoppingCartV2Component,
        CartEmptiedNotificationModalV2Component,
        WalletLoadingPageComponent,
        WalletLoadingPageV2Component,
        CartEndWarningModalV2Component,
        WalletLoadingPageV2SelectAmountComponent,
        WalletLoadingPageV2ChooseATicketComponent,
        WalletLoadingPageV2SelectCardComponent,
        DropdownMenuComponent,
        MobileDropdownMenuComponent
    ],
    exports: [
        HeaderComponent,
        FooterComponent,
        BasePageComponent,
        BaseSubPageComponent,
        MobileMenuComponent,
        NewMobileMenuComponent,
        SelectLanguageDialogComponent,
        HeaderShoppingCartComponent,
        HeaderShoppingCartCountdownTimerVisualComponent,
        HeaderShoppingCartCountdownTimerComponent,
        CartEmptiedNotificationModalComponent,
        CartEndWarningModalComponent,
        LandingHeaderComponent,
        LandingFooterComponent,
        HeaderLandingTemplateVlComponent,
        HeaderLandingTemplateGlComponent,
        HeaderTemplateComponent,
        HeaderStwComponent,
        FooterTemplateGlComponent,
        FooterTemplateVlComponent,
        FooterTemplateFiveColsComponent,
        FooterStwComponent,
        FooterAppComponent,
        SplashScreenLegacyComponent,
        AboutAppComponent,
        WalletLoadingPageComponent,
        WalletLoadingPageV2Component,
        HeaderShoppingCartV2Component,
        DropdownMenuComponent,
        MobileDropdownMenuComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        CoreModule,
        ComponentsModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        SwiperModule,
        LocalizeRouterModule.forChild([]),
        IonicModule.forRoot(),
        WidgetsModule,
        MatListModule,
        MatRadioModule,
        MatDividerModule,
        MatSelectModule,
        MatOptionModule,
        MatInputModule,
        MatFormFieldModule,
        OverlayModule
    ]
})
export class SharedModule {}
